import {CommonModule} from "@angular/common";
import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
import * as moment from "moment";

@Pipe({ name: 'tagstatus' })
export class InventoryStatus implements PipeTransform {
  /** * * @param value * @returns {string} */
  transform(value: string): string {
    var status = value.charAt(0).toUpperCase() + value.slice(1);;
    if (value == 'isUsed') {
      status = 'In Use'
    }
    else if (value == 'in_stock') {
      status = 'In Stock'
    }
    else if (value == 'not_allow') {
      status = 'Not Allow'
    }
    return status;
  }

}